import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { SdCurrencyPipe } from '../../../../pipes/currency.pipe';

@Component({
  selector: 'sd-grid-input-control',
  templateUrl: './grid-input-control.component.html',
  styleUrls: ['./grid-input-control.component.scss']
})
export class GridInputControlComponent implements OnDestroy, AfterViewInit {
  @Input() type: 'text' | 'number' | 'password' | 'email' | 'currency' = 'text';

  cModel: any;
  currencyModel: any;
  private previous: Date;
  @Input() set model(value: any) {
    this.cModel = value;
    this.currencyModel = this.currencyPipe.transform(value);
    this.ref.detectChanges();
  }
  @Output() modelChange = new EventEmitter();

  // Optional
  @Input() icon = 'fa fa-search';
  @Output() sdClick = new EventEmitter<any>();
  @Output() sdChange = new EventEmitter<any>();
  @Output() keyupEnter = new EventEmitter();

  @ViewChild('control') control: ElementRef;
  constructor(private ref: ChangeDetectorRef, private currencyPipe: SdCurrencyPipe) {
  }

  ngAfterViewInit() {
    this.ref.detectChanges();
  }

  ngOnDestroy() {
  }

  onChange = async (value: any) => {
    if (this.type === 'currency') {
      const delay = 500;
      this.previous = new Date();
      await new Promise(resolve => setTimeout(resolve, delay));
      const now = new Date();
      const dif = now.getTime() - this.previous.getTime();
      if (dif < delay) {
        return;
      }
      this.cModel = this.currencyToNumber(value);
      if (Number.isNaN(this.cModel)) {
        this.cModel = null;
      }
    } else {
      this.cModel = value;
    }
    this.modelChange.emit(this.cModel);
    this.sdChange.emit(this.cModel);
  }

  onKeyupEnter = () => {
    this.keyupEnter.emit(this.cModel);
  }

  onClick = () => {
    this.sdClick.emit(this.cModel);
  }

  private currencyToNumber = (value: any) => {
    value = (value || '').replace(/,/g, '');
    if (!value) {
      return null;
    }
    return +value;
  }
}
